import * as actionTypes from './actionTypes';
import { I_FavPopUpState } from './interfaces';

export const setCityLength = (payload: any) => ({
    type: actionTypes.SET_CITYLENGTH,
    payload,
});

export const setFilterItems = (payload: any) => ({
    type: actionTypes.SET_FILTERITEMS,
    payload,
});

export const setTempFilterItems = (payload: any) => ({
    type: actionTypes.SET_TEMPFILTERITEMS,
    payload,
});

export const setSortListBy = (payload: any) => ({
    type: actionTypes.SET_SORTLISTBY,
    payload,
});

export const setTagList = (payload: any) => ({
    type: actionTypes.SET_TAGLIST,
    payload,
});

export const setSwitchListBy = (payload: any) => ({
    type: actionTypes.SET_SWITCHLISTBY,
    payload,
});

export const setPageSizeM = (payload: any) => ({
    type: actionTypes.SET_PAGESIZEM,
    payload,
});
//新增全產品項目action
export const getData = (payload: any) => ({
    type: actionTypes.GET_DATA,
    payload,
});
export const setRecommends = (payload: any) => ({
    type: actionTypes.SET_RECOMMENDS,
    payload,
});

export const setFilterDataLoading = (payload: any) => ({
    type: actionTypes.SET_FILTERDATALOADING,
    payload,
});

// 全產品card 卡牌內容是共用一個store(沒有分M或PC store)
export const setCardInfo = (payload: any) => ({
    type: actionTypes.SET_CARDINFO,
    payload,
});
// 收藏內容
export const setFavList = (payload: any) => ({
    type: actionTypes.SET_FAVLIST,
    payload,
});

// 收藏提示框
export const setFavPopUp = (payload: I_FavPopUpState) => ({
    type: actionTypes.SET_FAVPOPUP,
    payload,
});
export const setShowFavPopUp = (payload: I_FavPopUpState) => ({
    type: actionTypes.SET_SHOWFAVPOPUP,
    payload,
});
export const setHideFavPopUp = () => ({
    type: actionTypes.SET_HIDEFAVPOPUP,
});

// M板時確定所有條件送出後更動，saga設定完卡牌資料後再設定為false
export const setSendEmitApi = (payload: any) => ({
    type: actionTypes.SET_MOBILE_EMIT_API,
    payload,
});

export type I_SetGetDataAction = ReturnType<typeof getData>;
export type I_SetRecommend = ReturnType<typeof setRecommends>;
export type I_FavPopUpAction = ReturnType<typeof setFavPopUp>;
